function getCurrentDate() {
	var currentdate = new Date();

	// To make sure we have a leading 0 for months, hours, minutes, and seconds
	// less than 10, we always prepend the '0' and then just get the last 2
	// characters in the string.
	var day = ('0' + currentdate.getDate()).slice(-2);
	var month = ('0' + (currentdate.getMonth()+1)).slice(-2);
	var year = currentdate.getFullYear();
	var hours = ('0' + currentdate.getHours()).slice(-2);
	var minutes = ('0' + currentdate.getMinutes()).slice(-2);
	var seconds = ('0' + currentdate.getSeconds()).slice(-2);

	var datetime = month + '/' +
		day  + '/' +
		year + ' @ ' +
		hours + ':' +
		minutes + ':' +
		seconds;
	return datetime;
}